import { IRegisterKiwiSaverUser } from './../../../models/registration/register';
import { Action } from '@ngrx/store';
import { HideLoader, ShowLoader } from 'src/app/shared/decorators/loader';
export const REGISTER_KIWISAVER = 'REGISTER_KIWISAVER';
export const REGISTER_KIWISAVER_REDIRECT = 'REGISTER_KIWISAVER_REDIRECT';
export const REGISTER_KIWISAVER_FAIL = 'REGISTER_KIWISAVER_FAIL';
export const REGISTER_KIWISAVER_SUCCESS = 'REGISTER_KIWISAVER_SUCCESS';
export const REGISTER_KIWISAVER_GET_STATUS = 'REGISTER_KIWISAVER_GET_STATUS';
export const REGISTER_KIWISAVER_GET_STATUS_SUCCESS = 'REGISTER_KIWISAVER_GET_STATUS_SUCCESS';
export const REGISTER_KIWISAVER_GET_STATUS_FAIL = 'REGISTER_KIWISAVER_GET_STATUS_FAIL';
export const REGISTER_KIWISAVER_UPDATE_ENTITY = 'REGISTER_KIWISAVER_UPDATE_ENTITY';


@ShowLoader()
export class RegisterKiwiSaver implements Action {
    readonly type = REGISTER_KIWISAVER;
    constructor(public payload: Partial<IRegisterKiwiSaverUser>) { }
}
export class RegisterKiwiSaverRedirect implements Action {
    readonly type = REGISTER_KIWISAVER_REDIRECT;
}


@HideLoader(REGISTER_KIWISAVER)
export class RegisterKiwiSaverFail implements Action {
    readonly type = REGISTER_KIWISAVER_FAIL;
    constructor(public payload: string) { }
}

@HideLoader(REGISTER_KIWISAVER)
export class RegisterKiwiSaverSuccess implements Action {
    readonly type = REGISTER_KIWISAVER_SUCCESS;
}

@ShowLoader()
export class RegistrationKiwiSaverGetStatus implements Action {
    readonly type = REGISTER_KIWISAVER_GET_STATUS;
}

@HideLoader(REGISTER_KIWISAVER_GET_STATUS)
export class RegistrationKiwiSaverGetStatusSuccess implements Action {
    readonly type = REGISTER_KIWISAVER_GET_STATUS_SUCCESS;
}


@HideLoader(REGISTER_KIWISAVER_GET_STATUS)
export class RegistrationKiwiSaverGetStatusFail implements Action {
    readonly type = REGISTER_KIWISAVER_GET_STATUS_FAIL;
    constructor(public payload: string) { }
}


export class RegistrationKiwiSaverUpdateEntity implements Action {
    readonly type = REGISTER_KIWISAVER_UPDATE_ENTITY;
    constructor(public payload: Partial<IRegisterKiwiSaverUser>) { }
}

export type RegistrationKiwiSaverActions = RegisterKiwiSaver | RegisterKiwiSaverRedirect | RegisterKiwiSaverFail | RegistrationKiwiSaverGetStatus | RegistrationKiwiSaverGetStatusFail | RegistrationKiwiSaverUpdateEntity;
